export default __webpack_public_path__ + "static/staff-hero-ed858a68ef12644ba781910f2b0f555c.webp";